import { Spinner } from './Spinner';
import { Text } from './Text';

export const LoadingStep = () => {
  return (
    <div className="flex flex-col items-center p-8">
      <Spinner />
      <div className="text-gray-900 mt-8">
        Please wait, this may take a few moments…
      </div>
    </div>
  );
};
